import actions from './actions'

const initialState = {
  id: '',
  name: '',
  role: '',
  email: '',
  project: '',
  avatar: '',
  authorized: false,
  loading: false,
  hiddeList: true,
  projectsList: [],
  projectsFirebase: {},
  userDisabled: false,
  passDisabled: false,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
